import TemplateView from '../../../TemplateView'
import messageResource from '../../../messageResource'
import SummaryRecord from './SummaryRecord'
import SummaryRecords from './SummaryRecords'

export default class ReportedTimeSummaryRecords extends TemplateView {
    constructor() {
        super()

        this.state = {
            myRecord: null,
            myTeamRecords: [],
            othersRecords: [],
            myTeamTotal: 0,
            othersTotal: 0,
            myTeamCollapsed: true,
            othersCollapsed: true,
        }

        this.onStatePropertyChanged('myRecord', (myRecord) => {
            this.$mySection.empty()
            if (myRecord !== null) {
                new SummaryRecord(this.$mySection, myRecord['formattedName'], false)
                    .init()
                    .setValue(myRecord['spentTime'])
                this.$mySection.show()
            } else {
                this.$mySection.hide()
            }
        })

        this.onStatePropertyChanged('myTeamTotal', (myTeamTotal) => {
            this.$myTeamTotalText.empty()
            new SummaryRecord(this.$myTeamTotalText, messageResource.getMessage('task.edit_panel.my_team_spent'), false)
                .init()
                .setValue(myTeamTotal !== null ? myTeamTotal : 0)
            this.find('.noAssignedUsersMsg').toggle(myTeamTotal === null)
        })

        this.onStatePropertyChanged('myTeamRecords', (myTeamRecords) => {
            this.$myTeamSection.toggle(myTeamRecords !== null)
            if (myTeamRecords !== null) {
                this.myTeamSummaryRecords.setState({
                    summaryRecords: myTeamRecords,
                })
                const hasRecords = myTeamRecords.length !== 0
                this.myTeamSummaryRecords.toggle(hasRecords)
                this.$myTeamTotalIcon.toggle(hasRecords)
                this.$myTeamTotal.toggleClass('hasIcon', hasRecords)
            }
        })

        this.onStatePropertyChanged('othersTotal', (othersTotal) => {
            this.$othersTotalText.empty()
            const hasOthersTotal = othersTotal !== null
            if (hasOthersTotal) {
                new SummaryRecord(this.$othersTotalText, messageResource.getMessage('task.edit_panel.others_spent'), false)
                    .init()
                    .setValue(othersTotal)
                this.$othersTotalText.show()
            } else {
                this.setState({
                    myTeamCollapsed: false,
                })
                this.$othersTotalText.hide()
            }
            this.$myTeamTotal.toggleClass('showTotal', hasOthersTotal)
        })

        this.onStatePropertyChanged('othersRecords', (othersRecords) => {
            this.othersSummaryRecords.setState({
                summaryRecords: othersRecords,
            })
            const hasRecords = othersRecords.length !== 0
            this.othersSummaryRecords.toggle(hasRecords)
            this.$othersTotalIcon.toggle(hasRecords)
            this.$othersTotal.toggleClass('hasIcon', hasRecords)
        })

        this.onStatePropertyChanged('myTeamCollapsed', (myTeamCollapsed) => {
            this.$myTeamRecords.toggle(!myTeamCollapsed)
            this.$myTeamSection.toggleClass('collapsed', myTeamCollapsed)
        })

        this.onStatePropertyChanged('othersCollapsed', (othersCollapsed) => {
            this.$othersRecords.toggle(!othersCollapsed)
            this.$othersSection.toggleClass('collapsed', othersCollapsed)
        })
    }

    templateHtml() {
        return "<div class='reportedTimeSummary'>" +
               "    <div class='mySection'/>" +
               "    <div class='myTeamSection'>" +
               "        <div class='myTeamTotal'>" +
               "            <div class='icon'/>" +
               "            <div class='text'></div>" +
               "        </div>" +
               "        <div class='myTeamRecords'></div>" +
               "        <div class='noAssignedUsersMsg'><%=noAssignedUsers%></div>" +
               "    </div>" +
               "    <div class='othersSection'>" +
               "        <div class='othersTotal'>" +
               "            <div class='icon'/>" +
               "            <div class='text'></div>" +
               "        </div>" +
               "        <div class='othersRecords'></div>" +
               "    </div>" +
               "</div>"
    }

    messageKeys() {
        return {
            noAssignedUsers: 'task.edit_panel.no_assigned_users',
        }
    }

    afterRender() {
        this.$mySection = this.find('.mySection')

        this.$myTeamSection = this.find('.myTeamSection')
        this.$myTeamTotalText = this.find('.myTeamTotal .text')
        this.$myTeamTotalIcon = this.find('.myTeamTotal .icon')
        this.$myTeamTotal = this.find('.myTeamTotal')
        this.$myTeamRecords = this.find('.myTeamRecords')
        this.myTeamSummaryRecords = new SummaryRecords(this.$myTeamRecords).init()

        this.$othersSection = this.find('.othersSection')
        this.$othersTotalText = this.find('.othersTotal .text')
        this.$othersTotalIcon = this.find('.othersTotal .icon')
        this.$othersTotal = this.find('.othersTotal')
        this.$othersRecords = this.find('.othersRecords')
        this.othersSummaryRecords = new SummaryRecords(this.$othersRecords).init()

        this.$myTeamTotal.on('click', () => {
            if (this.state.myTeamRecords.length !== 0)
                this.setState({
                    myTeamCollapsed: !this.state.myTeamCollapsed,
                })
        })
        this.$othersTotal.on('click', () => {
            if (this.state.othersRecords.length !== 0)
                this.setState({
                    othersCollapsed: !this.state.othersCollapsed,
                })
        })

        this.renderInitialState()
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/task/reportedTime/ReportedTimeSummaryRecords.js